import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {Translate} from 'views/module';

const SectionHeading = (props) => {
  const {
    expression,
  } = props;

  return (
    <Typography
      sx={{
        fontSize: '11px',
        fontWeight: 600,
        lineHeight: '14px',
        letterSpacing: '0.04em',
        color: '#A8A49E',
        mb: 2,
      }}
    >
      <Translate expression={expression} />
    </Typography>
  );
};

SectionHeading.propTypes = {
  expression: PropTypes.string.isRequired,
};

export default React.memo(SectionHeading);
